export default __webpack_public_path__ + "static/media/notifications.959302ff.svg";